<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')" modal_style="modal-small">
      <!-- MODAL TITLE -->
      <div slot="modal-title" class="title-row">
        <img v-lazy="localImg('Switcher.svg')" alt="" />
        <span class="font-weight-bold text-uppercase">User Mode Settings</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body" class="switch-mode-modal">
        <!-- ALERT  -->
        <div
          class="alert-comp w-100 border rounded-5"
          :class="'alert-' + alert.type"
          v-if="alert.show"
        >
          {{ alert.msg }}
        </div>

        <div class="title-text">Question Mode</div>

        <!-- OPTION ROW  -->
        <div class="option-row">
          <!-- PRATICE MODE  -->
          <div
            class="option-card"
            @click="updateQuestionMode('practice')"
            :class="question_mode === 'practice' ? 'active-option-card' : null"
          >
            <div class="avatar brand_red_light_bg border_brand_red">
              <img v-lazy="localImg('Path.svg')" alt="" class="avatar-img" />
            </div>
            <!-- TITLE TEXT  -->
            <div class="title">Practice Mode</div>

            <!-- META TEXT  -->
            <div class="meta">Practice with Gradely Questions</div>
          </div>

          <!-- EXAM MODE  -->
          <div
            class="option-card"
            @click="updateQuestionMode('exam')"
            :class="question_mode === 'exam' ? 'active-option-card' : null"
          >
            <div class="avatar brand_accent_light_bg border_brand_accent">
              <img
                v-lazy="localImg('Notebook.svg')"
                alt=""
                class="avatar-img"
              />
            </div>
            <!-- TITLE TEXT  -->
            <div class="title">Exam Mode</div>

            <!-- META TEXT  -->
            <div class="meta">Practice with Past Questions</div>
          </div>
        </div>

        <template v-if="account_type === 'student' && false">
          <div class="title-text">Instruction Mode</div>

          <!-- OPTION ROW  -->
          <div class="option-row">
            <template v-if="connected_to_school">
              <div
                class="option-card"
                @click="updateInstructionMode(0)"
                :class="
                  summer_mode === 'inactive' || !summer_mode
                    ? 'active-option-card'
                    : null
                "
              >
                <div class="avatar brand_inverse_light_bg border_brand_inverse">
                  <img
                    v-lazy="localImg('Buildings.svg')"
                    alt=""
                    class="avatar-img"
                  />
                </div>
                <!-- TITLE TEXT  -->
                <div class="title">My School</div>

                <!-- META TEXT  -->
                <div class="meta">Instructors from: {{ school_name }}</div>
              </div>
            </template>

            <template v-if="summer_mode">
              <div
                class="option-card"
                @click="updateInstructionMode(1)"
                :class="summer_mode === 'active' ? 'active-option-card' : null"
              >
                <div class="avatar brand_inverse_light_bg border_brand_inverse">
                  <img
                    v-lazy="localImg('BookOpen.svg')"
                    alt=""
                    class="avatar-img"
                  />
                </div>
                <!-- TITLE TEXT  -->
                <div class="title">Summer School</div>

                <!-- META TEXT  -->
                <div class="meta">Instructors from: Summer School Program</div>
              </div>
            </template>

            <template v-if="!summer_mode">
              <div class="option-card new-to-summer-school">
                <div class="avatar brand_inverse_light_bg border_brand_inverse">
                  <img
                    v-lazy="localImg('BookOpen.svg')"
                    alt=""
                    class="avatar-img"
                  />
                </div>
                <!-- TITLE TEXT  -->
                <div class="title">Summer School</div>

                <!-- META TEXT  -->
                <div class="meta">
                  Amazing activities waiting for you.
                </div>

                <button
                  class="btn btn-inverse-outline z-depth-0"
                  @click="goToEnrollmentPage"
                >
                  Enroll Today
                </button>
              </div>
            </template>
          </div>
        </template>

        <!-- BUTTON ROW  -->
        <div
          class="button-row d-flex justify-content-end align-items-start position-relative mt-2"
          style="margin-bottom: -40px"
        ></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";

export default {
  name: "SwitchModeModal",

  components: {
    Modal,
  },

  computed: {
    ...mapGetters([
      "getCatchupMode",
      "getSummerStatus",
      "getExamConfigureState",
    ]),
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      child_id: this.$route.params.id,
      connected_to_school: false,
      school_name: "Gradely",

      question_mode: "",
      summer_mode: false,

      alert: {
        msg: "",
        type: "",
        show: false,
      },
    };
  },

  created() {
    this.account_type === "student" ? this.getSchoolClassDetails() : null;
  },

  mounted() {
    this.question_mode = this.getCatchupMode;
    // this.summer_mode = this.getSummerStatus;
  },

  methods: {
    ...mapActions([
      "updateCatchupMode",
      "updateSummerMode",
      "getChildClassDetails",
    ]),

    // UPDATE QUESTION MODE
    updateQuestionMode(mode) {
      this.question_mode = mode;

      this.updateCatchupMode(mode)
        .then((response) => {
          //   console.log(response.code);
          if (response.code === 200) {
            this.showDialogResponse(
              `Question mode successfully updated to ${mode}`,
              "success"
            );

            setTimeout(() => this.$emit("closeTriggered"), 2500);
            if (mode === "exam" && !this.getExamConfigureState)
              this.$emit("showExamConfig");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // UPDATE INSTRUCTION MODE
    updateInstructionMode(mode) {
      let pre_summer_mode = this.summer_mode === "active" ? 1 : 0;
      this.summer_mode = mode === 1 ? "active" : "inactive";

      if (mode === 1 && pre_summer_mode === 1) {
        this.summer_mode = "inactive";
        mode = 0;
      }

      let payload = {
        student_id: this.child_id,
        summer_school: mode,
      };

      this.updateSummerMode(payload)
        .then((response) => {
          if (response.code === 200) {
            this.showDialogResponse(
              `Instruction mode successfully updated`,
              "success"
            );

            setTimeout(() => location.reload(), 1000);
          }
        })
        .catch((err) => console.log(err));
    },

    // GET CHILD SCHOOL CLASS DETAILS
    getSchoolClassDetails() {
      this.getChildClassDetails(this.child_id)
        .then((response) => {
          //   console.log(response);
          if (response.code === 200) {
            let { data } = response;
            this.connected_to_school = data.has_school;
            this.school_name = data.school_name;

            if (data.in_summer_school === 1) this.summer_mode = "active";
            else if (data.in_summer_school === 0) this.summer_mode = "inactive";
            else this.summer_mode = false;
          }
        })
        .catch((err) => console.log(err));
    },

    // GO TO ENROLLMENT PAGE
    goToEnrollmentPage() {
      this.$router.push({ name: "SummerSchoolConnectChildOnboardingStudent" });
    },

    showDialogResponse(msg, type) {
      this.alert = {
        msg,
        type,
        show: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.title-row {
  img {
    @include equal_min_edge(34);
    margin-right: 10px;
  }
  font-size: 13.5px;
}

.switch-mode-modal {
  position: relative;
  top: -10px;

  .alert-comp {
    padding: 10px;
    font-size: 13.75px;
    margin-bottom: 10px;
  }

  .alert-success {
    color: $brand_navy;
    border: 1px solid $brand_green;
    background: $brand_green_light;
  }

  .alert-error {
    color: $brand_navy;
    border: 1px solid $brand_red;
    background: $brand_red_light;
  }

  .title-text {
    color: $color_text;
    font-weight: 700;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .option-row {
    @include flex_row_between_nowrap;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .option-card {
    @include flex_column_center;
    border-radius: 10px;
    width: 47%;
    min-height: 170px;
    height: auto;
    padding: 15px;
    cursor: pointer;
    background: $color_white;
    transition: all 0.4s ease-in-out;

    &:hover {
      transform: scale(0.98);
    }

    .avatar {
      padding: 5px;
      @include equal_min_edge(38);
      margin-bottom: 10px;

      .avatar-img {
        width: 75%;
      }
    }

    .title {
      font-weight: 600;
      color: $brand_navy;
      text-align: center;
      font-size: 13.75px;
      line-height: 18px;
      margin-bottom: 4px;
      width: 100%;
    }

    .meta {
      width: 100%;
      text-align: center;
      color: $color_grey_dark;
      font-size: 11.5px;
      line-height: 13px;
    }
  }

  .active-option-card {
    background: $brand_navy;
    .title {
      color: #fff;
    }

    .meta {
      color: $border_grey;
    }
  }

  .new-to-summer-school {
    background: transparent;
    border: 1px solid $border_grey;

    &:hover {
      transform: scale(1);
    }

    .avatar {
      @include equal_min_edge(30);
      margin-bottom: 7px;
    }

    .btn {
      margin-top: 12px;
      padding: 8px 16px !important;
      font-size: 11px !important;
    }
  }
}
</style>
